

































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import { ITableParams } from "@/interface";

@Component({
  components: { ViewLoader, AlertBox }
})
export default class Table extends Vue {
  @Prop({ default: "" }) readonly id!: string;
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: [] }) readonly actions!: Array<any>;
  @Prop({ default: [] }) readonly columns!: Array<any>;
  @Prop({ default: [] }) readonly data!: Array<any>;
  @Prop({ default: false }) readonly selectable!: boolean;
  @Prop({
    default: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 20,
      to: 1,
      total: 1
    }
  })
  readonly meta!: ITableParams;

  private dataLength: number | null = null;
  private currentPage = 1;
  private total = 0;
  private from = 0;
  private to = 0;
  private firstPage = 1;
  private lastPage = 0;
  private perPage = 0;
  private searchFilter = "";
  private sortBy = "";
  private sortOrder = "asc";
  private debounce = 0;

  private refetch(): void {
    this.$emit("fetchQuery", {
      page: this.currentPage,
      per_page: this.perPage,
      search: this.searchFilter,
      sort_by: this.sortBy,
      sort_order: this.sortOrder,
      to: this.to
    });
  }

  private goToFirstPage(): void {
    if (!this.disabledFirstPage) {
      this.currentPage = 1;
      this.refetch();
    }
  }

  private goToPreviousPage(): void {
    if (!this.disabledPreviousPage) {
      this.currentPage--;
      this.refetch();
    }
  }

  private goToNextPage(): void {
    if (!this.disabledNextPage) {
      this.currentPage++;
      this.refetch();
    }
  }

  private goToLastPage(): void {
    if (!this.disabledLastPage) {
      this.currentPage = this.lastPage;
      this.refetch();
    }
  }

  get disabledFirstPage(): boolean {
    return this.currentPage === 1;
  }

  get disabledPreviousPage(): boolean {
    return this.currentPage === 1;
  }

  get disabledNextPage(): boolean {
    return this.currentPage === this.lastPage;
  }

  get disabledLastPage(): boolean {
    return this.currentPage === this.lastPage;
  }

  @Watch("meta")
  metaChanged(meta: ITableParams): void {
    if (meta.current_page !== undefined && meta.current_page !== null) {
      this.currentPage = meta.current_page;
    }
    if (meta.total !== undefined && meta.total !== null) {
      this.total = meta.total;
    }
    if (meta.from !== undefined && meta.from !== null) {
      this.from = meta.from;
    }
    if (meta.to !== undefined && meta.to !== null) {
      this.to = meta.to;
    }
    if (meta.last_page !== undefined && meta.last_page !== null) {
      this.lastPage = meta.last_page;
    }
    if (meta.per_page !== undefined && meta.per_page !== null) {
      this.perPage = meta.per_page;
    }
  }

  @Watch("data")
  dataChanged(data: Array<any>): void {
    this.dataLength = data.length;
  }

  @Watch("perPage")
  perPageChanged(): void {
    this.refetch();
  }

  @Watch("searchFilter")
  searchFilterChanged(): void {
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.refetch();
    }, 600);
  }

  @Watch("sortBy")
  sortByChanged(): void {
    this.refetch();
  }

  @Watch("sortOrder")
  sortOrderChanged(): void {
    this.refetch();
  }
}
